<template>
  <div class="body-container login">
    <div class="input-box">
      <div class="label">手机号码</div>
      <span class="text">{{phone}}</span>
    </div>
    <div class="input-box">
      <div class="label">验证码</div>
      <input type="number" placeholder="请输入验证码" v-model="code">
      <div class="code-btn blue" @click="getCodeAjax(phone)" v-if="codeIndex==CODE_SIZE">获取验证码</div>
      <div class="code-btn" v-else>{{codeIndex}}S</div>
    </div>
    <van-button round class="form-btn" @click="submit">验证</van-button>
  </div>
</template>

<script>
import {common,codeTools} from "@/api/mixins";

const CODE_SIZE = 60;
export default {
  mixins: [common,codeTools],
  data() {
    return {
      key:"",
      phone:"",
      code:"",
    };
  },
  mounted() {
    this.key = this.$route.query.key;
    this.phone = this.$route.query.phone;
  },
  methods: {
    async getCodeAjax(mobile){
      this.timerStart();
      this.$http({
        type: "POST",
        url: '/api/policyManager/sendCodeByOrderNo',
        data: {
          orderNo: this.key,
          source: "policy_manager",
        }
      }).then(res => {

      }).catch(e => {
        window.clearInterval(this.timer);
        this.codeIndex = CODE_SIZE;
      })
    },
    loginSuccess(){
      if(this.$route.query.goPage){
        location.replace(this.$route.query.goPage)
      }else if(sessionStorage.bdgjLoginPage){
        location.replace(sessionStorage.bdgjLoginPage)
      } else{
        location.replace("/m/bdgj/order")
      }
    },
    submit(){
      if (!this.code) {
        this.$notice.msg("请输入验证码");
        return;
      }
      this.loading = true;
      const params = {
        isFromWx: 0,
        orderNo: this.key,
        code: this.code
      }
      this.$http({
        type: "POST",
        url: "/api/policyManager/loginByOrderNo",
        data: params
      }).then(resData => {
        localStorage.bdgj_token = resData.data.token;
        localStorage.bdgj_user = JSON.stringify(resData.data.data);
        this.loading = false;
        sessionStorage.insureUniqueId = this.key;
        this.loginSuccess();
      }).catch(e =>{
        console.log(e);
        this.loading = false;
      })
    }

  },

};
</script>

<style lang="scss" scoped>
@import "./loginByOrder";
</style>
